import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { useSearchBox, useConfigure } from 'react-instantsearch'

import useSearchQueries from '../../../../../hooks/useSearchQueries'
import { getCountryAndLocaleStrings } from '../../../../../utils/locales'
import { QueryParam } from '../../../../../utils/constants'

const useSearchState = () => {
  const [searchTerm, setSearchTerm] = useState('')

  const { query, isReady, locale: countryAndLocale } = useRouter()
  const { locale } = getCountryAndLocaleStrings(countryAndLocale)

  const { suggestions } = useSearchQueries()

  const searchQuery = query[QueryParam.search]
  const wordCount = searchTerm.split(' ').length

  const { query: typesenseQuery, refine } = useSearchBox()

  // Configure search filters
  useConfigure({
    // Filter out all other languages
    facetsRefinements: {
      lang: [locale],
    },
    // Limit to current + 2 word suggestions to not immediately give long ones
    numericRefinements: { word_count: { '>=': [wordCount], '<=': [wordCount + 2] } },
  })

  // Sync with URL query parameter
  useEffect(() => {
    if (isReady && searchQuery && typeof searchQuery === 'string') {
      setSearchTerm(searchQuery)
      refine(searchQuery)
    } else {
      setSearchTerm('')
      refine('')
    }
  }, [searchQuery, isReady])

  return {
    searchTerm,
    setSearchTerm,
    results: suggestions,
    refine,
    locale,
    wordCount,
    typesenseQuery,
  }
}

export default useSearchState
